import { Controller } from "@hotwired/stimulus"

// Rewrites a server-rendered <time datetime="..."> (always UTC) into the
// viewer's own locale + timezone -- Intl.DateTimeFormat picks both up
// automatically when locale/timeZone are omitted, which is exactly "the
// user's time setting". The server-rendered text stays in place as the
// no-JS/crawler-safe fallback until this runs.
export default class extends Controller {
  connect() {
    const iso = this.element.getAttribute("datetime")
    if (!iso) return

    const date = new Date(iso)
    if (Number.isNaN(date.getTime())) return

    this.element.textContent = new Intl.DateTimeFormat(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(date)
  }
}
